import { useEffect, useState } from "react";
import { adminListReports } from "../../lib/services";

export default function AdminReports() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await adminListReports();
        if (mounted) setItems(r.items || []);
      } finally {
        if (mounted) setLoaded(true);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <section data-testid="admin-reports" className="px-5 py-5">
      <p className="font-mono text-[11px] text-white/50 mb-4">
        read-only for now. moderation actions land in a later phase.
      </p>
      {!loaded ? (
        <p className="font-mono text-xs text-white/40">loading...</p>
      ) : items.length === 0 ? (
        <p className="font-mono text-xs text-white/40">no reports.</p>
      ) : (
        <ul className="space-y-2">
          {items.map((r) => (
            <li
              key={r.id}
              data-testid={`admin-report-${r.id}`}
              className="border-2 border-white/15 p-3"
            >
              <div className="font-mono text-[10px] uppercase tracking-widest text-white/50">
                {r.targetType} · {r.targetId} ·{" "}
                <span className="text-acid">{r.status}</span>
              </div>
              <div className="font-mono text-sm text-white/90 mt-1">{r.reason}</div>
              <div className="font-mono text-[10px] text-white/40 mt-1">
                {(r.createdAt || "").slice(0, 16).replace("T", " ")}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
